import type { Profile } from "@/lib/types"

/**
 * The expert packs, as every page names them.
 *
 * Mirrors `backend/career_copilot/core/packs.py`; a backend test
 * (`test_docs_agree_with_code.py`) fails if a pack is added there and not here.
 * Static rather than fetched so that a label never flickers in after a request.
 */
export const PACK_LABEL: Record<Profile, string> = {
  automotive_cyber: "Automotive cybersecurity",
  devops: "DevOps",
  ai_eng: "AI engineering",
  software_eng: "Software engineering",
  data_eng: "Data engineering & analytics",
  embedded: "Embedded software",
  qa_test: "QA & test automation",
  general: "General",
}

export const PACK_TAGLINE: Record<Profile, string> = {
  automotive_cyber: "Vehicle security · standards · testing",
  devops: "Platform · delivery · reliability",
  ai_eng: "Retrieval · pipelines · model safety",
  software_eng: "Backend · full-stack · system design",
  data_eng: "Pipelines · warehousing · data quality",
  embedded: "C/C++ · real-time · safety-critical",
  qa_test: "Test strategy · automation · quality",
  general: "Any other role · your CV and the career guides",
}

export const PACK_SKILLS: Record<Profile, string[]> = {
  automotive_cyber: ["ISO 21434", "UNECE R155", "TARA", "ECU testing"],
  devops: ["Kubernetes", "CI/CD", "GitOps", "DORA"],
  ai_eng: ["RAG", "MLOps", "LLMOps", "Evaluation"],
  software_eng: ["APIs", "System design", "Testing", "Code review"],
  data_eng: ["SQL", "dbt", "Spark", "Data quality"],
  embedded: ["C/C++", "RTOS", "AUTOSAR", "MISRA"],
  qa_test: ["ISTQB", "Playwright", "Test pyramid", "CI testing"],
  general: ["CV", "Applications", "Interviews", "Career change"],
}

/** Every pack, in the order the backend lists them. */
export const ALL_PACKS = Object.keys(PACK_LABEL) as Profile[]
